import React, { useEffect, useContext, useState } from "react";
import { CommonService } from "../../services/common/common.service";
import { useTranslation } from "react-i18next";
import { TasksProvider, TasksContext } from "../../store";
import TasksContent from "../../components/tasks-content/tasks-content.component";
import HeaderComponent from "../../components/header/header.component";
import TaskFilter from "../../components/task-filter/taskFilter.component";
import "./tasks.page.scoped.sass";
import { headerWithTableHeight } from "src/statics/header";
import { history } from "react-router-guard";
import TasksCalendarMob from "../../components/tasks-calendar-mob/tasks-calendar-mob.component";

export default function TasksPage(props: any) {
  const id = props.location.search.split("=")[1];
  if (!id) {
    history.push({
      pathname: "buildings",
    });
  }
  return (
    <TasksProvider>
      <TasksPageContent buildingId={id} />
    </TasksProvider>
  );
}

export function TasksPageContent(props: any) {
  const { buildingId } = props;
  const { buildingName, clearActiveFilters } = useContext(TasksContext);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const commonService = new CommonService();

  const [t] = useTranslation();

  useEffect(() => {
    const title = t("tasks");
    commonService.setTitle(title);
    clearActiveFilters();
    // eslint-disable-next-line
  }, []);

  window.addEventListener("resize", function() {
    setScreenWidth(
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth)
  });

  return (
    <>
      {screenWidth > 480 && (
        <div id="desktopView">
          <HeaderComponent
            title="cleaning plan"
            subtitle={buildingName}
            headerHeight={headerWithTableHeight}
            displayMenu={false}
          >
            <div className="filters-container">
              <TaskFilter />
            </div>
          </HeaderComponent>
          <TasksContent buildingId={buildingId} />
        </div>
      )}
      {screenWidth <= 480 && (
        <div id="mobView">
          <HeaderComponent
            title="cleaning plan"
            subtitle={buildingName}
            displayMenu={false}
            mobView={true}
            displayLogo={true}
          />
          <TasksCalendarMob buildingId={buildingId} />
        </div>
      )}
    </>
  );
}
